import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import EnvironmentManager from 'Utils/environmentManager';
import Icon from 'Components/Icon';
import BetSlipRow from './betSlipRow';
import { useDispatch, useSelector } from 'react-redux';
import { decimalFormatter } from '../../../../utils/decimalFormatter';
import { dotConverter } from '../../../../utils/converters';
import mixpanel from 'Utils/mixpanel';
import {
  updateUserBetSlipSettings,
  computePredicta,
  openDrawer,
  undoLastRemovedBet,
  openModal,
  fetchPredictaSuggestion
} from 'Store/actions';
import BetSlipSettingsContent from '../Footer/BetSlipSettingsContent';
import History from 'Store/history';
import PredictaCampaignModal from 'Components/Modal/PredictaCampaignModal';
import Modal from 'Components/Modal';
import axios from 'axios';
import BetslipModal from '../../BetslipModal';
import Message from '../../Modal/Message';
import { Button } from 'Components/Button';
import SportTypeIcon from '../../SportTypeIcon';
import { GTA_SPORT_TYPE_NAMING } from 'Store/constants/sportTypes';
import LottieLoader from '../../LottieLoader';
import { OUTRIGHTS } from 'Store/constants/sportTypes';


const Content = props => {
  const avatar = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_avatar' });
  const recommendedWarningText = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_betslip_toast_message_text' });
  // eslint-disable-next-line react/prop-types
  const { eventScores, betSlipData, showCampaignMessage, toggleBetSlip, onRemoveClick, toggleBetSlipBanker, isMBSValid, betSlipClose, showDeletedBackMatchToast, deletedMatchToastKey } = props;
  const zirveWinningText = EnvironmentManager.getMessageText({ key: 'zirveoran_betslip_possible_winning_text' });
  const zirveDailyLimitText = EnvironmentManager.getMessageText({ key: 'zirveoran_betslip_daily_limit_text' });
  const zirveMaxDailyLimit = EnvironmentManager.getMessageText({ key: 'zirveoran_max_daily_limit' });
  const zirveDailyLimitTextArr = (zirveDailyLimitText || '').split('%@');
  const zirveWinningTextArr = (zirveWinningText || '').split('%@');
  const zirveOranSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_switch' }) == 'true';
  const { topWinEnabled } = useSelector(state => state?.auth?.data);
  const minStake = EnvironmentManager.getMessageText({ key: 'TM_MIN_STAKE_TYPE_TMPRO' });

  const { coupon, couponDetails } = betSlipData;

  // En düşük predicta probability değerini bulan fonksiyon
  const getLowestPredictaProbabilityEvent = (predictaResult, couponDetails) => {
    if (!predictaResult?.predictaSelections || predictaResult.predictaSelections.length === 0) return null;

    let lowestProbability = 1;
    let lowestProbabilityEvent = null;
    let lowestProbabilityIndex = -1;

    predictaResult.predictaSelections.forEach((selection, index) => {
      if (selection.predictaProbability < lowestProbability
         || (selection.predictaProbability === lowestProbability && index > lowestProbabilityIndex)) {
        lowestProbability = selection.predictaProbability;
        lowestProbabilityEvent = couponDetails.find(event => event.eventId === selection.eventId);
        lowestProbabilityIndex = index;
      }
    });

    return lowestProbabilityEvent;
  };

  const [lowestProbabilityEvent, setLowestProbabilityEvent] = useState(null);

  // En düşük predicta probability'ye sahip maçı çıkarıp kalan maçlarla predicta API isteği atan fonksiyon
  const fetchPredictaWithoutLowestProbability = async () => {
    if (couponDetails.length > 0 && !betSlipData?.validateData?.isLoading) {
      const payload = {
        system: [couponDetails.length],
        selections: couponDetails.map(detail => ({
          eventId: detail.eventId,
          marketId: detail.bets[0]?.marketId,
          outcomeNo: detail.bets[0]?.marketOutcomeNo,
        })),
      };

      try {
        const result = await dispatch(computePredicta(payload));

        if (result?.predictaSelections) {
          const lowestProbabilityEvent = getLowestPredictaProbabilityEvent(result, couponDetails);

          if (lowestProbabilityEvent) {
            const remainingEvents = couponDetails.filter(event => event.eventId !== lowestProbabilityEvent.eventId);

            const newPayload = {
              system: [remainingEvents.length],
              selections: remainingEvents.map(detail => ({
                eventId: detail.eventId,
                marketId: detail.bets[0]?.marketId,
                outcomeNo: detail.bets[0]?.marketOutcomeNo,
              })),
            };

            const newResult = await dispatch(computePredicta(newPayload));

            if (newResult?.calculatedProbability) {
              const formattedProbability = formatProbability(newResult.calculatedProbability);
              return formattedProbability;
            }
          }
        }
        return null;
      } catch (error) {
        return null;
      }
    }
    return null;
  };

  const [isVisible, setIsVisible] = useState(false);
  const [isHtwVisible, setIsHtwVisible] = useState(true);
  const { isAuthenticated } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const hasTWinOdd = couponDetails.some(event => event.bets.some(bet => bet?.topWinOdds));
  const state = useSelector(state => state);
  const { data } = useSelector(state => state.auth);
  let calcDiff;

  const calculateDiff = (couponDetails, minStake) => {
    let calculatedOdds = 1;
    let primaryOdd = 1;
    couponDetails.forEach(coupon => {
      const bet = coupon.bets[0]; // İlk bet objesini al
      const odd = parseFloat(bet.odd);
      const topWinOdd = bet.topWinOdds ? parseFloat(bet.topWinOdds) : null;

      if (topWinOdd) {
        primaryOdd *= topWinOdd;
      } else {
        primaryOdd *= odd;
      }

      calculatedOdds *= odd;
    });
    calcDiff = parseFloat((primaryOdd - calculatedOdds) * minStake);
    return decimalFormatter(calcDiff);
  };

  const auth = useSelector(state => state.auth);
  const [isPredictaVisible, setIsPredictaVisible] = useState(true);
  const [isPredictaNotCalcText, setIsPredictaNotCalcText] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);
  const [isClosedPredictaVisible, setIsClosedPredictaVisible] = useState(false);
  const [calculatedProbability, setCalculatedProbability] = useState(null);
  const predictaSwitch = EnvironmentManager.getMessageText({ key: 'predicta_switch' }) == 'true';
  const suggestionPredictaSwitch = EnvironmentManager.getMessageText({ key: 'predicta_suggestion_toogle' }) == 'true';
  const predictaCampaignMassSwitch = EnvironmentManager.getMessageText({ key: 'predicta_bonus_whole_mass_toogle' }) === 'true';
  const predictaCampaignSwitch = EnvironmentManager.getMessageText({ key: 'predicta_bonus_toogle' }) == 'true';
  const predictaCampaignPercentage = parseFloat(EnvironmentManager.getMessageText({ key: 'predicta_bonus_whole_mass_predicta_percentage' })) * 100;
  const predictaNonLoginSwitch = EnvironmentManager.getMessageText({ key: 'predicta_nonlogin_switch' }) == 'true';
  const predictaClosingActionSwitch = EnvironmentManager.getMessageText({ key: 'predicta_closing_action_switch' }) == 'true';
  const predictaDisplayMatchCount = EnvironmentManager.getMessageText({ key: 'predicta_suggestion_display_match_count' });
  const predictaSuggestionModalText = EnvironmentManager.getMessageText({ key: 'predicta_suggestion_popup_text' });
  const predictaSuggestionMassSwitch = EnvironmentManager.getMessageText({ key: 'predicta_suggestion_whole_mass_toogle' }) == 'true';
  const predictaSuggestionModalReplaceText = predictaSuggestionModalText.split('%@');
  const [predictaSuggetion, setPredictaSuggetion] = useState(false);
  const predictaTitle = EnvironmentManager.getMessageText({ key: 'predicta_text' });
  const predictaDesc = EnvironmentManager.getMessageText({ key: 'predicta_irresponsibility_declaration' });
  const predictaNotCalcText = EnvironmentManager.getMessageText({ key: 'predicta_not_calculation_text' });
  const [predictaCampaignModal, setPredictaCampaignModal] = useState(false);
  const [showPredictaModal, setShowPredictaModal] = useState(false);
  const [suggestionPredictaCalculatedProbability, setSuggestionPredictaCalculatedProbability] = useState(null);
  const wsBettingStatus = couponDetails.filter(e=>e.wsBettingStatus);
  const [previousProbability, setPreviousProbability] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [predictaError, setPredictaError] = useState(false);
  const [predictaNonLoginClosed, setPredictaNonLoginClosed] = useState(false);
  const undoOnBetslipToggle = EnvironmentManager.getMessageText({ key: 'undo_on_betslip_toogle' }) == 'true';
  const animationDuration = EnvironmentManager.getMessageText({ key: 'undo_on_betslip_display_time' });
  const undoOnToastMessage = EnvironmentManager.getMessageText({ key: 'undo_on_betslip_toast_message' });
  const matchName = betSlipData?.lastRemovedBet?.name || null;
  let truncatedMatchName = null;
  const lastRemoved = betSlipData.lastRemovedBet;
  const deletedMatchSportType = betSlipData.lastRemovedBet?.sportType;
  const columnCount = betSlipData?.validateData?.data?.columnCount;
  const { targetProbability = 0, bonusRatio = 0 } = useSelector(
    ({ userCampaign }) => userCampaign?.predictaBonusCampaign?.data ?? {}
  );
  const [hasCheckedExistence, setHasCheckedExistence] = useState(false);

  if (matchName) {
    const maxLength = 30;
    truncatedMatchName = matchName.length > maxLength
      ? matchName.slice(0, maxLength) + '...'
      : matchName;
  }
  const undoOnBetsliptToastMessage = undoOnToastMessage.replace('%@', `<b>${truncatedMatchName}</b>`);
  const isOutrightSport = OUTRIGHTS.includes(deletedMatchSportType);

  const shouldShowUndoToast
    = lastRemoved
    && !lastRemoved.wsBettingStatus
    && deletedMatchSportType !== undefined
    && !isOutrightSport
    && couponDetails.length > 0
    && showDeletedBackMatchToast
    && truncatedMatchName;

  const { acceptHigherOdds, acceptLowerOdds, acceptLiveEvents, acceptPrematchEvents, acceptPredictaProbability } = state.auth.data;
  const [settings, setSettings] = useState({
    acceptHigherOdds: acceptHigherOdds,
    acceptLowerOdds: acceptLowerOdds,
    acceptLiveEvents: acceptLiveEvents,
    acceptPrematchEvents: acceptPrematchEvents,
    acceptPredictaProbability: acceptPredictaProbability,
  });

  const handleClose = () => {
    setIsVisible(!isVisible);
  };

  const handlePredictaCampaignClick = async () => {
    await axios.post('/users/campaign/predicta-bonus/click');
    setPredictaCampaignModal(true);
  };

  const fetchPredicta = async () => {
    if (couponDetails.length > 0 && !betSlipData?.validateData?.isLoading) {
      setCalculatedProbability(null);
      setPredictaError(false);
      setLowestProbabilityEvent(null);

      const payload = {
        system: betSlipData?.validateData?.data?.selectedSystems,
        selections: couponDetails.map(detail => ({
          eventId: detail.eventId,
          marketId: detail.bets[0]?.marketId,
          outcomeNo: detail.bets[0]?.marketOutcomeNo,
        })),
      };
      try {
        const result = await dispatch(computePredicta(payload));
        if (result?.calculatedProbability) {
          const formattedProbability = formatProbability(result.calculatedProbability);
          setCalculatedProbability(formattedProbability);
          setIsPredictaNotCalcText(true);
          setPredictaError(false);

          if (result.predictaSelections) {
            const lowestEvent = getLowestPredictaProbabilityEvent(result, couponDetails);
            setLowestProbabilityEvent(lowestEvent);
          }
        } else {
          setPredictaError(true);
          setCalculatedProbability(null);
          setLowestProbabilityEvent(null);
        }
      } catch (error) {
        setCalculatedProbability(null);
        setPredictaError(true);
        setLowestProbabilityEvent(null);
      }
    }
  };
  const formatProbability = value => {
    const percentage = value * 100;
    if (percentage < 0.01) return '0.01';
    return percentage.toFixed(2);
  };

  const formatDisplayedProbability = probability => {
    if (!probability) return '0,00';
    const [integerPart, decimalPart] = probability.split('.');
    if (decimalPart === '00') {
      return integerPart;
    }
    return probability.replace('.', ',');
  };

  const handleOutsideClick = e => {
    if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
      setShowTooltip(false);
    }
  };

  const handleOpenSettings = () => {
    dispatch(openDrawer({
      isOpen: true,
      title: EnvironmentManager.getMessageText({ key: 'betslip_settings_title' }) || 'Ayarlar',
      className: 'betslip-settings-drawer',
      showCloseOnBottom: true,
      content: <BetSlipSettingsContent />,
      container: document.getElementsByClassName('betslip')[0],
      position: { web: 'bottom', mobile: 'bottom' },
    }));
    setShowToast(false);
  };


  const onBetslipSettingsUpdate = async () => {
    mixpanel.track('Close Winning Probability on Betslip', { 'Close Button Name ': EnvironmentManager.getMessageText({ key: 'predicta_closing_button2' }) });
    const updatedSettings = { ...settings, acceptPredictaProbability: false };
    setSettings(updatedSettings); // İlk olarak state'i güncelle.
    await dispatch(updateUserBetSlipSettings(updatedSettings)); // Sonrasında güncellenmiş state'i gönder.
    setIsPredictaVisible(true);

    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  useEffect(() => {
    setIsHtwVisible(columnCount > 1);
  }, [columnCount]);

  const handleUndoClick = async () => {
    mixpanel.track('Click Undo on Betslip', { 'Teams ': matchName });
    await dispatch(undoLastRemovedBet());
  };

  useEffect(() => {
    if (auth.isAuthenticated && suggestionPredictaSwitch && !predictaSuggestionMassSwitch && !hasCheckedExistence) {
      dispatch(fetchPredictaSuggestion()).then(result => {
        setPredictaSuggetion(result?.existsInRecommendationTargetAudience);
        setHasCheckedExistence(true);
      }).catch(() => {
        setPredictaSuggetion(false);
        setHasCheckedExistence(true);
      });
    }
  }, [auth.isAuthenticated, suggestionPredictaSwitch, predictaSuggestionMassSwitch, hasCheckedExistence]);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    if (auth.isAuthenticated && ((predictaSwitch && acceptPredictaProbability) || suggestionPredictaSwitch))  {
      fetchPredicta();
    }
    if (coupon?.bets?.length === 1 && couponDetails[0]?.bets[0]?.isRecommended) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
    if (couponDetails.length === 0) {
      setIsClosedPredictaVisible(false);
      setIsPredictaVisible(true);
      setCalculatedProbability(null);
      setPredictaNonLoginClosed(false);
    }
    return () => {
      setIsVisible(false);
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [couponDetails, coupon, acceptPredictaProbability, auth.isAuthenticated, predictaSwitch, suggestionPredictaSwitch]);

  useEffect(() => {
    const currentProbability = parseFloat(calculatedProbability);
    const prevProbability = parseFloat(previousProbability);

    if (couponDetails.length === 0) {
      setPreviousProbability(null);
      return;
    }

    const triggerAnimation = () => {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setPreviousProbability(calculatedProbability);
        setIsAnimating(false);
      }, 500); // Animasyon süresi

      return () => clearTimeout(timer);
    };

    if (previousProbability === null && currentProbability !== null) {
      return triggerAnimation();
    }

    const shouldAnimate
      = !predictaTitle.includes('%@')
      && previousProbability !== null
      && !isNaN(currentProbability)
      && !isNaN(prevProbability)
      && currentProbability > prevProbability;

    if (shouldAnimate) {
      return triggerAnimation();
    }

    setPreviousProbability(calculatedProbability);
  }, [calculatedProbability, predictaTitle, previousProbability, couponDetails]);

  const isPredictaClosed = () => {
    return (
      auth.isAuthenticated
      && predictaClosingActionSwitch
      && acceptPredictaProbability
      && !(remainingMbs > 0)
      && couponDetails.length > 0
      && !isHtwVisible
      && !isPredictaVisible
      && !isClosedPredictaVisible
    );
  };

  const getRecommendedWarningClass = () => {
    const hasPredictaCampaignConditions = predictaCampaignSwitch && (predictaCampaignMassSwitch || targetProbability !== 0);
    const hasZirveOranConditions = zirveOranSwitch && topWinEnabled && hasTWinOdd;
    const isNonLoginPredicta = predictaNonLoginSwitch && !predictaNonLoginClosed && !auth.isAuthenticated;
    const hasValidMatchCount = couponDetails.length > 1 && couponDetails.length <= predictaDisplayMatchCount;
    const isPredictaActive = predictaSwitch || suggestionPredictaSwitch;
    const isAcceptedPredictaVisible = acceptPredictaProbability && isPredictaVisible && predictaSwitch;

    return classnames({
      'recommended_warning--predicta-calculated': (!hasPredictaCampaignConditions && !isPredictaNotCalcText && calculatedProbability !== null) || isPredictaClosed() || (isAcceptedPredictaVisible && isPredictaActive && !hasPredictaCampaignConditions && calculatedProbability !== null),
      'recommended_warning--default': (predictaSwitch && !isPredictaNotCalcText && calculatedProbability === null)
        || (!isPredictaVisible && hasZirveOranConditions && !hasValidMatchCount) || (!predictaSwitch && hasZirveOranConditions && !hasValidMatchCount)
        || (isPredictaVisible && calculatedProbability === null && !predictaError),
      'hastopwin--predicta--non-login': isNonLoginPredicta,
      'hastopwin-predicta-closed': (hasZirveOranConditions && hasPredictaCampaignConditions && !isPredictaVisible && suggestionPredictaSwitch)
        || (!isPredictaVisible && hasZirveOranConditions && hasValidMatchCount) || (!predictaSwitch && hasZirveOranConditions && hasValidMatchCount && suggestionPredictaSwitch),
      'predicta_bonus--suggestion-predicta': hasZirveOranConditions && hasPredictaCampaignConditions && isPredictaVisible && suggestionPredictaSwitch && calculatedProbability !== null,
      'hastopwin--predicta-bonus-campaign': auth.isAuthenticated && hasPredictaCampaignConditions && !predictaError && calculatedProbability !== null,
      'predicta_bonus--hastopwin-suggestion-predicta': hasZirveOranConditions && hasPredictaCampaignConditions && !suggestionPredictaSwitch && calculatedProbability !== null,
      'hastopwin-on': predictaSwitch && isPredictaVisible && hasZirveOranConditions && calculatedProbability !== null && hasValidMatchCount && !hasPredictaCampaignConditions,
      'recommended_warning--predicta-not-calculated':
        (isAcceptedPredictaVisible && isPredictaActive && calculatedProbability === null && predictaError)
        || (auth.isAuthenticated && predictaSwitch && hasZirveOranConditions && isPredictaVisible && calculatedProbability === null && predictaError)
        || (predictaSwitch && hasPredictaCampaignConditions && predictaError),
      'recommended_warning--suggestion-predicta':
        !isPredictaVisible && suggestionPredictaSwitch && hasValidMatchCount
        && (predictaSuggestionMassSwitch || predictaSuggetion),
    });
  };

  const getSuggestionPredictaClass = () => {
    const hasZirveOranConditions = zirveOranSwitch && topWinEnabled && hasTWinOdd;
    const hasPredictaCampaignConditions = predictaCampaignSwitch && (predictaCampaignMassSwitch || targetProbability !== 0);
    const hasDefaultConditions = !predictaSwitch || !isPredictaVisible || (!acceptPredictaProbability && suggestionPredictaSwitch);

    return classnames({
      'recommended_warning--default': hasDefaultConditions,
      'predicta_bonus--hastopwin-suggestion-predicta': suggestionPredictaSwitch && hasPredictaCampaignConditions && hasZirveOranConditions,
      'predicta_bonus--suggestion-predicta': suggestionPredictaSwitch && hasPredictaCampaignConditions && !hasZirveOranConditions,
      'recommended_warning--suggestion-predicta': !suggestionPredictaSwitch && hasZirveOranConditions,
      'recommended_warning--predicta-calculated': !hasPredictaCampaignConditions && !suggestionPredictaSwitch && !hasZirveOranConditions,
    }) || (hasZirveOranConditions ? 'recommended_warning--suggestion-predicta' : 'recommended_warning--predicta-calculated');
  };

  const getMarginBottom = isLastRow => {
    if (!isLastRow) return null;

    const isUserAuthenticated = auth.isAuthenticated;
    const hasPredictaConditions = (predictaSwitch && acceptPredictaProbability);
    const hasZirveOranConditions = zirveOranSwitch && topWinEnabled && hasTWinOdd;
    const hasPredictaCampaignConditions = predictaCampaignSwitch && (predictaCampaignMassSwitch || targetProbability !== 0);

    if (isUserAuthenticated) {
      if (zirveOranSwitch && topWinEnabled && hasTWinOdd && !acceptPredictaProbability) {
        return '40px';
      }
      if (hasPredictaConditions && calculatedProbability && hasZirveOranConditions && hasPredictaCampaignConditions && suggestionPredictaSwitch) {
        return '200px';
      }
      if (hasZirveOranConditions && hasPredictaConditions && calculatedProbability && suggestionPredictaSwitch) {
        return '170px';
      }
      if (hasZirveOranConditions && hasPredictaConditions && hasPredictaCampaignConditions && calculatedProbability) {
        return '150px';
      }
      if (hasPredictaConditions && predictaCampaignSwitch && hasPredictaCampaignConditions && calculatedProbability) {
        return '100px';
      }
      if (hasPredictaConditions && hasZirveOranConditions) {
        return '110px';
      }
      if (predictaNonLoginSwitch && !predictaNonLoginClosed && hasZirveOranConditions) {
        return '120px';
      }
      if (hasPredictaConditions && calculatedProbability && suggestionPredictaSwitch) {
        return '120px';
      }

    }

    if (hasPredictaConditions) {
      return '60px';
    }
    if (predictaNonLoginSwitch && zirveOranSwitch && topWinEnabled) {
      return '70px';
    }

    return null;
  };

  const handleClosePredicta = () => {
    mixpanel.track('Close Winning Probability on Betslip');
    setIsPredictaVisible(false);
  };

  const handlePredictaSuggestion = async () => {
    const result = await fetchPredictaWithoutLowestProbability();
    setSuggestionPredictaCalculatedProbability(result);
    setShowPredictaModal(true);
    mixpanel.track('View Predicta Suggestion Popup', { 'Current Predicta Percentage': calculatedProbability, 'Suggested Predicta Percentage': result });
  };

  const handlePredictaModalClose = () => {
    setShowPredictaModal(false);
    dispatch({ type: 'SET_PREDICTA_SUGGESTION_ACCEPTED', payload: false });
  };

  const emptyStateArea = <div className="betslip__empty-state">
    <div className="betslip__empty-state__text">
      Kuponunda hiç maç bulunmuyor.
    </div>
    <div className="betslip__empty-state__button" onClick={ () => toggleBetSlip('/iddaa') } >
      Maç Ekle
    </div>
  </div>;

  const _renderContent = (coupon.bets.length < 1 || couponDetails.length < 1)
    ? emptyStateArea
    : couponDetails && couponDetails.map((event, index) => {
      if (event.bets.length > 0) {
        const isLastRow = index === couponDetails.length - 1;

        return (
          <div
            key={ index }
            /* eslint-disable-next-line no-nested-ternary */
            style={ { marginBottom: getMarginBottom(isLastRow) } }
          >
            <BetSlipRow
              isSystem={ isHtwVisible }
              key={ index }
              onRemoveClick={ onRemoveClick }
              onBankerClick={ toggleBetSlipBanker }
              data={ event }
              eventScores={ eventScores }
              toggleBetSlip={ toggleBetSlip }
              betSlipClose = { betSlipClose }
              closeInteraction
              topWinEnabled = { topWinEnabled }
            /></div>
        );
      }
    });
  const campaignMessage = EnvironmentManager.getMessageText({ key: 'betslip_campaign_information' });
  const mbsValidationMessage = EnvironmentManager.getMessageText({ key: 'betslip_mbs_validation_hint_message' }) || 'MBS kuralı nedeniyle kuponuna maç eklemeye devam etmelisin.';
  const mbsCombinationMessage = EnvironmentManager.getMessageText({ key: 'betslip_mbs_combination_message' }) || 'Kuponunda yer alan en az bir bahis, MBS kurallarına göre diğer eklediklerinle kombinlenemez.';

  const maxMbsCount = Math.max(...couponDetails.filter(e=>!e.wsBettingStatus).map(couponDetail => couponDetail.bets[0].mbs));
  const remainingMbs = maxMbsCount - couponDetails.filter(e=>!e.wsBettingStatus).length;

  const _renderCampaignMessage = couponDetails.length && showCampaignMessage
    ? <div className="campaign-message">
      <Icon iconName='svgLike' /> { campaignMessage }
    </div>
    : null;


  const _renderRecommendedWarning = (couponDetails.length  > 0) && isVisible
    ? <div className={ `recommended_warning ${remainingMbs > 0 ? 'withMbs' : ''} ${getRecommendedWarningClass()}` }>
      <img className="recommended_warning__avatar authors__row__img__avatar"
        src={ avatar }
        alt={ avatar }/>
      <div className="recommended_warning__message-wrapper">
        <Icon className="close-btn" iconName="svgCloseCircleBlack" onClick={ handleClose }/>
        <div className="text" dangerouslySetInnerHTML={ { __html: recommendedWarningText } }/>
      </div>
    </div>
    : null;

  const _renderHasTopWinWarning = hasTWinOdd && (couponDetails.length  > 0) && isHtwVisible
    ? <div className={ `hastopwin_warning ${remainingMbs > 0 ? 'withMbs' : ''} ${getRecommendedWarningClass()}` }>
      <div className="hastopwin_warning__message-wrapper">
        <div className="text">{ EnvironmentManager.getMessageText({ key: 'zirve_oran_betslip_system_coupon_info' }) }</div>
        <Icon className="close-btn" iconName="svgCloseTimes" onClick={ ()=> setIsHtwVisible(false) }/>
      </div>
    </div>
    : null;

  const _renderHasTopWinInfo = betSlipData?.validateData?.data?.iddaaTopWinResponse?.hasTopWin && hasTWinOdd && (couponDetails.length  > 0) && !isHtwVisible
    ? <div className={ `htw-message ${remainingMbs > 0 ? 'withMbs' : ''} ${getRecommendedWarningClass()}` }>
      <div className="text" dangerouslySetInnerHTML={ { __html: `${zirveWinningTextArr[0]}
            <b>${isMBSValid ? decimalFormatter(betSlipData?.validateData?.data?.iddaaTopWinResponse?.expectedWinAmountBonus)
        : calculateDiff(couponDetails, minStake)} BP</b>
       ${(zirveWinningTextArr[1] || '').replace('BP', '')} ${zirveDailyLimitTextArr[0]}
      <b>${zirveMaxDailyLimit} BP</b> ${(zirveDailyLimitTextArr[1] || '').replace('BP', '')} ` } }  />
      <button
        onClick={ () => dispatch(openModal('getDetailInformationBetslipModal')) }
      ><span>{ EnvironmentManager.getMessageText({ key: 'zirveoran_betslip_possible_winning_button_name' }) }</span></button>
    </div>
    : null;

  const _renderHasTopWinLimit = isAuthenticated && !data?.availableTopWinPoint && hasTWinOdd && (couponDetails.length  > 0) && !isHtwVisible
    ? <div className={ `htw-message ${remainingMbs > 0 ? 'withMbs' : ''} ${getRecommendedWarningClass()}` }>
      <div className="text">{ EnvironmentManager.getMessageText({ key: 'zirveoran_betslip_full_limit_text' }) }</div>
      <button
        onClick={ () => dispatch(openModal('getDetailInformationModal', { isShowSelect: false }))  }
      ><span>{ EnvironmentManager.getMessageText({ key: 'zirveoran_betslip_possible_winning_button_name' }) }</span></button>
    </div>
    : null;

  const _renderMessage = () => {
    if (betSlipData.validateData?.error?.code === 1021) {
      return <div className="mbs-message">
        <i className="bly bly-info-circle-inverse bly-warning bly-size24"/>
        <span dangerouslySetInnerHTML={ { __html: mbsCombinationMessage } }/>
      </div>;
    }

    return couponDetails.length && !isMBSValid && remainingMbs > 0
      ? <div className="mbs-message">
        <i className="bly bly-info-circle-inverse bly-warning bly-size24"/>
        <span dangerouslySetInnerHTML={ { __html: mbsValidationMessage.replace('%@', remainingMbs) } }/>
      </div>
      :      null;
  };


  const lowestProbabilityBet = lowestProbabilityEvent?.bets?.[0];

  const showLowestProbabilityTopWin
    = lowestProbabilityEvent?.hasTopWin && zirveOranSwitch && topWinEnabled;

  const _renderSuggestionPredicta = (calculatedProbability !== null) && !predictaError && !betSlipData?.validateData?.isLoading && auth.isAuthenticated && (wsBettingStatus.length === 0) && remainingMbs < 0 && (couponDetails.length > 1) && (couponDetails.length <= predictaDisplayMatchCount) && !isHtwVisible
    ? <>
              <div className={ `button-wrapper ${getSuggestionPredictaClass()}` } onClick={ handlePredictaSuggestion }>
                <div className="predicta-suggestion-lottie">
                  <LottieLoader type="suggestionPredicta" loop={ true } autoplay/>
                </div>
                <span className="button-text">{ EnvironmentManager.getMessageText({ key: 'predicta_suggestion_text' }) }</span>
                <div className="button-icon">
                  <Icon className="arrow-icon" iconName="svgPredictaArrow"/>
                </div>
              </div>
      { showPredictaModal && suggestionPredictaCalculatedProbability !== null && (
        <div>
          <BetslipModal
            type={ 'success' }
            title={ EnvironmentManager.getMessageText({ key: 'predicta_suggestion_popup_title' }) }
            position={ { web: 'center' } }
            className="betslip-modal--small predicta-suggestion-title"
            onClose={ handlePredictaModalClose }
          >
            <div className="predicta-suggestion-message">
              <Message type="none" buttonConfig="">
                <span className="match-card-text">{ predictaSuggestionModalReplaceText[0] }<br/><span className="match-card-text-old-odd">%{ formatDisplayedProbability(calculatedProbability) }</span> oranından <Icon className="match-card-icon" iconName="svgPredictaModalArrow"/> <span className="match-card-text-new-odd">%{ formatDisplayedProbability(suggestionPredictaCalculatedProbability) }</span> { predictaSuggestionModalReplaceText[2] }</span>
              </Message>
            </div>

            <div className="match-card-container">
              <div className="match-card">
                <div className="match-header">
                  <div className="icon">
                    <SportTypeIcon type={ lowestProbabilityEvent?.sportType }/>
                  </div>
                  <span>{ lowestProbabilityEvent?.name }</span>
                </div>
                <div className="market-name">{ lowestProbabilityBet?.marketName }</div>
                <div className="odds-box">
                  <div className="selection">{ lowestProbabilityBet?.betType }</div>

                  <div className={ `match-odd ${showLowestProbabilityTopWin ? '' : 'single-line'}` }>
                    { showLowestProbabilityTopWin && (
                      <span className="odd-old">
                        { dotConverter(lowestProbabilityBet?.odd) }
                      </span>
                    ) }

                    <span className="odd-new">
                      { dotConverter(
                        showLowestProbabilityTopWin
                          ? lowestProbabilityBet?.topWinOdds
                          : lowestProbabilityBet?.odd
                      ) }
                    </span>
                  </div>
                </div>
              </div>
            </div>

            { /* eslint-disable-next-line react/jsx-no-undef */ }
            <Button
              className="btn--primary btn--block betslip__settings-sheet__update-button"
              onClick={ () => {
                if (!lowestProbabilityBet?.id) return;

                onRemoveClick(lowestProbabilityBet.id);
                setShowPredictaModal(false);

                dispatch({
                  type: 'SET_PREDICTA_SUGGESTION_ACCEPTED',
                  payload: true
                });

                mixpanel.track('Remove Match - Predicta Suggestion', {
                  Teams: lowestProbabilityEvent?.name,
                  'Event ID': lowestProbabilityEvent?.eventId,
                  'Event Sport': GTA_SPORT_TYPE_NAMING[lowestProbabilityEvent?.sportType],
                  Odd: lowestProbabilityBet?.odd,
                  'Market Name': lowestProbabilityBet?.marketName,
                  'Selection Name': lowestProbabilityBet?.betType
                });
              } }
            >
              { EnvironmentManager.getMessageText({
                key: 'predicta_suggestion_popup_cta_button'
              }) }
            </Button>
            <span className="match-card-info">{ predictaDesc }</span>
          </BetslipModal>
        </div>
      ) }
    </>
    : null;

  // eslint-disable-next-line no-nested-ternary
  const _renderPredicta = acceptPredictaProbability && (calculatedProbability !== null) && auth.isAuthenticated && (wsBettingStatus.length === 0) && !(remainingMbs > 0) && (couponDetails.length > 0) && !isHtwVisible && isPredictaVisible && !isClosedPredictaVisible
    ? <div className="predicta predicta-height predicta-between">
      <div className="predicta-header" style={ { paddingTop: 5 } }>
        <div className="predicta-header">
          <div
            className="text">
            { predictaTitle.split('%@') }
          </div>
          <div
            className={ `text highlighted-text ${isAnimating ? 'heartbeat-once' : ''}` }
          >
            %{ calculatedProbability ? formatDisplayedProbability(calculatedProbability) : '0' }
          </div>
        </div>
        <div className="predicta-btn-closed">
          <Icon className="btn-closed" iconName="svgCloseCircleBlack" onClick={ handleClosePredicta }/>
        </div>
      </div>
      <div className="progress-bar">
        <div className="progress-bar__fill" style={ { width: `${calculatedProbability || 0}%` } }
        />
      </div>
      { predictaCampaignSwitch && (predictaCampaignMassSwitch || (!predictaCampaignMassSwitch && targetProbability !== 0 && bonusRatio !== 0)) && (
        <>
          <div className="predicta-campaign" onClick={ () => handlePredictaCampaignClick() }>
            <div className="predicta-campaign__text">
              <span>
                { /* eslint-disable-next-line no-nested-ternary */ }
                { predictaCampaignMassSwitch
                  ? parseFloat(calculatedProbability) >= predictaCampaignPercentage
                    ? EnvironmentManager.getMessageText({ key: 'predicta_qualified_bonus_text' })
                    : EnvironmentManager.getMessageText({ key: 'predicta_unqualified_bonus_text' })
                  : parseFloat(calculatedProbability) >= (targetProbability * 100)
                    ? EnvironmentManager.getMessageText({ key: 'predicta_qualified_bonus_text' })
                    : EnvironmentManager.getMessageText({ key: 'predicta_unqualified_bonus_text' })
                }
              </span>
              <div className="predicta-campaign__text--animation">
                <img
                  src="/public/loaders/predicta-money-anim.gif"
                  alt="Predicta Bonus"
                  width="40"
                  height="40"
                />
              </div>
            </div>
            <div className="predicta-campaign__button">
              <span>
                { EnvironmentManager.getMessageText({ key: 'predicta_bonus_text_button' }) }
              </span>
            </div>
          </div>
          { predictaCampaignModal && (
            <Modal
              onClose={ () => setPredictaCampaignModal(false) }
              buttonArea={ {
                primaryButton: {
                  onClick: ()=> {
                    setPredictaCampaignModal(false);
                  },
                  label: EnvironmentManager.getMessageText({ key: 'predicta_bonus_popup_cta_button' })
                }
              } }
            >
              <PredictaCampaignModal calculatedProbability={ calculatedProbability } />
            </Modal>
          ) }
        </>
      ) }
      <div className="text predicta-description">{ predictaDesc }
      </div>
    </div>
    : null;

  const _renderPredictaNonLogin = !predictaNonLoginClosed && !auth.isAuthenticated && !(remainingMbs > 0) && (couponDetails.length > 0)
    ? <div className="predicta predicta-height predicta-between">
      <div className="predicta-header" style={ { paddingTop: 5 } }>
        <div className="predicta-header">
          <div
            className="text">
            { predictaTitle.split('%@') }
          </div>
          <div
            className="text highlighted-text non-login-predicta-calculated"
          >
            %75
          </div>
        </div>
        <div className="predicta-btn-closed">
          <Icon className="btn-closed" iconName="svgCloseCircleBlack" onClick={ () => {
            mixpanel.track('Close Winning Probability on Betslip');
            setPredictaNonLoginClosed(true);
          } }/>
        </div>
      </div>
      <div className="progress-bar progress-bar-margin">
        <div className="progress-bar__fill progress-bar-non-login"
        />
      </div>
      <div className="text predicta-description">
        <button className="btn-non-login-predicta"
          onClick={ () => {
            mixpanel.track('Click See Possibility');
            History.push('/giris-yap');
          } }
        ><span className="btn-text-color">{ EnvironmentManager.getMessageText({ key: 'predicta_nonlogin_redirect_login_button_name' }) }</span></button>
      </div>
    </div>
    : null;

  const _renderPredictaNotCalculated = predictaError && (!calculatedProbability) && !betSlipData?.validateData?.isLoading && isPredictaVisible && isPredictaNotCalcText
  && !(remainingMbs > 0) && !isClosedPredictaVisible && auth.isAuthenticated && (couponDetails.length > 0)
    ? (
      <div className="predicta">
        <div className="predicta-header" onClick={ () => setShowTooltip(!showTooltip) }>
          <div className="warning-text">
            <span dangerouslySetInnerHTML={ { __html: predictaNotCalcText } } />
            <div><Icon className="warning-icon" iconName="svgInfo" /></div>
          </div>
        </div>
        { showTooltip && (
          <div ref={ tooltipRef } className='tooltip tooltip--coupon tooltip--bottom tooltip--chance-games predicta-warning-tooltip'>
            <div className="text-p10">
              <span className="text-title">{ EnvironmentManager.getMessageText({ key: 'predicta_toast_message_main_text' }) } </span>
              <ul className="text-desc">
                <li>{ EnvironmentManager.getMessageText({ key: 'predicta_toast_message_first_item' }) },</li>
                <li>{ EnvironmentManager.getMessageText({ key: 'predicta_toast_message_second_item' }) },</li>
                <li>{ EnvironmentManager.getMessageText({ key: 'predicta_toast_message_third_item' }) },</li>
                <li>{ EnvironmentManager.getMessageText({ key: 'predicta_toast_message_fourth_item' }) } { EnvironmentManager.getMessageText({ key: 'predicta_toast_message_last_item' }) }</li>
              </ul>
            </div>
          </div>
        ) }
      </div>
    ) : null;


  const _renderPredictaIsClosed = auth.isAuthenticated && predictaClosingActionSwitch && acceptPredictaProbability && !(remainingMbs > 0) && (couponDetails.length > 0) && !isHtwVisible && !isPredictaVisible && !isClosedPredictaVisible
    ? <div className="predicta predicta-height predicta-isClosed">
      <div className="btn-closed btn-closed-warning">
        <div>
          <Icon className="btn-closed" iconName="svgCloseCircleBlack" onClick={ () => {
            setIsPredictaVisible(true);
          } }/>
        </div>
      </div>
      <button className="btn-predicta"
        onClick={ () => {
          setIsClosedPredictaVisible(true);
          mixpanel.track('Close Winning Probability on Betslip', { 'Close Button Name ': EnvironmentManager.getMessageText({ key: 'predicta_closing_button1' }) });
        } }
      ><span>{ EnvironmentManager.getMessageText({ key: 'predicta_closing_button1' }) }</span></button>
      <button className="btn-predicta"
        onClick={ () => onBetslipSettingsUpdate() }
      ><span>{ EnvironmentManager.getMessageText({ key: 'predicta_closing_button2' }) }</span></button>
    </div>
    : null;

  const _renderPredictaClosedToastMessage = auth.isAuthenticated && predictaSwitch && predictaClosingActionSwitch &&  !acceptPredictaProbability && showToast ? <div className="predicta-warning">
    <div className="text-warning-m">
      <span>{ EnvironmentManager.getMessageText({ key: 'predicta_closed_toast_message' }) }</span>
    </div>
    <div className="warning-closed">
      <button className="btn-settings" onClick={ handleOpenSettings }>
        <Icon className="icon-settings" iconName="svgIconSettings"/>
        Ayarlar&apos;a Git
      </button>
    </div>
  </div>
    : null;

  const _renderUndoOnBetslipToast = shouldShowUndoToast ? (
    <div key={ deletedMatchToastKey } className="deleted-match-back-warning">
      <div className="text-warning-m">
        <span dangerouslySetInnerHTML={ { __html: undoOnBetsliptToastMessage } } />
      </div>
      <div className="warning-closed">
        <button className="btn-settings" onClick={ handleUndoClick }>
          <div className="deleted-match-back-icon" style={ { '--fill-duration': `${animationDuration}s`, '--trash-duration': '0.5s' } }>
            <div className="circle" />
            <Icon className="trash-icon" iconName='svgTrashGreyIcon' />
          </div>
          { EnvironmentManager.getMessageText({ key: 'undo_on_betslip_button_name' }) }
        </button>
      </div>
    </div>
  ) : null;

  const betslipContentClass = classnames({
    betslip__content: true,
    betslip__content__message: couponDetails.length && !isMBSValid || betSlipData.validateData?.error?.code === 1021
  });

  return (
    <div className={ betslipContentClass }>
      { _renderContent }
      { undoOnBetslipToggle && _renderUndoOnBetslipToast }
      { suggestionPredictaSwitch && (predictaSuggestionMassSwitch || (!predictaSuggestionMassSwitch && predictaSuggetion)) && _renderSuggestionPredicta }
      { predictaSwitch && predictaNonLoginSwitch && _renderPredictaNonLogin }
      { predictaSwitch && _renderPredicta }
      { predictaSwitch && _renderPredictaNotCalculated }
      { predictaSwitch && _renderPredictaIsClosed }
      { predictaSwitch && _renderPredictaClosedToastMessage }
      { _renderMessage() }
      { _renderCampaignMessage }
      { _renderRecommendedWarning }
      { zirveOranSwitch && topWinEnabled && _renderHasTopWinInfo }
      { zirveOranSwitch && topWinEnabled && _renderHasTopWinWarning }
      { zirveOranSwitch && topWinEnabled && _renderHasTopWinLimit }
    </div>
  );
};

Content.propTypes = {
  betSlipData: PropTypes.object,
  onRemoveClick: PropTypes.func,
  toggleBetSlip: PropTypes.func,
  toggleBetSlipBanker: PropTypes.func,
  eventScores: PropTypes.object,
  showCampaignMessage: PropTypes.bool,
  isMBSValid: PropTypes.bool,
  betSlipClose: PropTypes.func
};

export default Content;
